import styled from 'styled-components';
import { textStyles, token } from '@bynder/design-system';

export const StyledHeading = styled.h3`
    ${textStyles.headingS}
`;

export const StyledBadgeText = styled.span`
    ${textStyles.uiTextM}
    color: ${token.colorText}
`;
